export default __webpack_public_path__ + "static/media/anis-site-mockup_4.508151b6.mp4";